import { useMemo } from 'react'
import { Icon, type TIconProps } from '~/components/icon'
import { useInputMultiSelectContext } from '../../input-multi-select'
import type {
  InputMultiSelectHelperTextProps,
  InputMultiSelectScopedProps,
} from '../../input-multi-select.types'
import { InputMultiSelectHelperTextVariants } from './index.styles'

export const InputMultiSelectHelperText = ({
  withIcon,
  iconName = 'rdicon-warning-circle',
  children,
  __scopeInputMultiSelect,
  ...props
}: InputMultiSelectScopedProps<InputMultiSelectHelperTextProps>) => {
  const { disabled, hasError, readonly } = useInputMultiSelectContext(
    'InputMultiSelectHelperText',
    __scopeInputMultiSelect
  )

  const symbol = hasError ? 'rdicon-warning-circle' : iconName

  const iconColor = useMemo((): TIconProps['color'] => {
    if (readonly) return 'colorTextNeutralReadonly'
    if (disabled) return 'colorTextNeutralDisabled'
    if (hasError) return 'colorTextDangerAlternative'
    return 'colorTextNeutralAlternative'
  }, [disabled, hasError, readonly])

  if (!children) return null

  return (
    <div
      {...props}
      aria-disabled={disabled}
      className={InputMultiSelectHelperTextVariants({
        hasError,
        disabled,
        readOnly: readonly,
      })}
    >
      {withIcon && (
        <div className="flex items-center">
          <Icon symbol={symbol} color={iconColor} size="tiny" />
        </div>
      )}
      <span className="line-clamp-2 flex-1">{children}</span>
    </div>
  )
}
